import axios from 'axios'

export default class Areas {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/areas/${id}`
    this.urlItens = `${url}/api/unimed/areas/itens/${id}`
    this.urlTipoArea = `${url}/api/unimed/areas/tipoAreaDisponiveis/${id}`
    this.urlEmail = `${url}/api/unimed/areas/reenviarEmail/${id}?areaId=`
    this.urlIniciar = `${url}/api/unimed/areas/iniciarEdicao/${id}`
    this.tokenBearer = tokenBearer
  }

  putAdicionar () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.urlIniciar}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  putEditar (areaId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.urlIniciar}/${areaId}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAreas (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  putAreas (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  deleteAreas (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getItens () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlItens,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getTipoArea () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlTipoArea,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async reenviarEmail (idArea) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlEmail}${idArea}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
